import { Box, Grid, MenuItem, TableSortLabel } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Dropdown } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { createGlobalStyle } from 'styled-components'

import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API, UTIL*/
import DoctorScheduleApi from 'api/counter/doctor-schedule.api'
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import FucntionPrint from 'component/Print/print'
import FilterSelect from 'component/Select/FilterSelect'
import { APPOINTMENT_STATUS } from 'features/auth/confirm-appointment'
import SchedulesList from './SchedulesDoctorList'

/** STYLED */

/** STYLED */
import TreatmentApi from 'api/dentists/treatment.api'
import { closeModal, resetModal, showModal } from 'app/slice/modal.slice'
import * as UseStyled from 'features/report/useStyled'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import PageModal from 'new-components/modal/page-modal'
import { useDispatch, useSelector } from 'react-redux'
import { dateToView } from 'utils/date.utils'
import { UseSnCode } from 'utils/useSnCode'
import { ExportSchedulesDoctorToExcel } from './ExportDfToExcel'
import SchedulesDoctorStaus from './SchedulesDoctorStaus'

const PrintStyles = createGlobalStyle`
  @media print {
    .no-print,
    .modal-backdrop,
    .MuiModal-root {
      display: none !important;
    }
  }
`

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

interface DentistInterface {
  dentistId: number
  dentistFullname: string
}
const headCells = [
  { id: '0', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.TIME', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '1', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.RANG_TIME', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '2', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.CN', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '3', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.PT', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '4', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.SN', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '5', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.PATIENT_NAME', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '6', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.PHONE', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.OPERATIVE_TYPE', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '8', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.OPERATIVE', width: '400x', align: 'center', class: 'text-nowrap' },
  { id: '9', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.STATUS', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '10', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.PRICE', width: 'auto', align: 'left', class: 'text-ellipsis' },
  { id: '11', disablePadding: false, labelKey: 'LAB', align: 'left', width: 'auto', class: 'text-ellipsis' },
  { id: '12', disablePadding: false, labelKey: 'X-RAY', align: 'left', width: '80px', class: 'text-ellipsis' },
  { id: '13', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.SPACIAL', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '14', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.PRACTICE', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '15', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.REMARK', width: 'auto', align: 'left', class: 'text-nowrap' },
  { id: '16', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.CREATE_BY', width: 'auto', align: 'center', class: 'text-nowrap' },
  { id: '17', disablePadding: false, labelKey: 'REPORT.TABLE.SCHEDULES_DOCTOR.UPDATE_BY', width: 'auto', align: 'center', class: 'text-nowrap' }
]

export default function SchedulesDoctor() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange

  const [branchId, setBranchId] = useState<number>(getBranch())
  const [branches, setBranches] = useState<any>(getBranch())
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [selectStatus, setSelectStatus] = useState<any[]>(['ALL', ...Object.values(APPOINTMENT_STATUS)])
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')

  const [SchedulesData, getSchedulesData] = useState<any[]>([])
  const [schedulesPage, setSchedulesPage] = useState<number>(1)
  const [schedulesTypePage, setSchedulesTypePage] = useState<number>(1)
  const [schedulesPageLimit, setSchedulesPageLimit] = useState<number>(10)
  const [operativeTypeId, setOperativeTypeId] = useState<number>(0)
  const [operativeType, setOperativeType] = useState<any>()
  const [operativeId, setOperativeId] = useState<number>(0)
  const [operative, setOperative] = useState<any>()


  const [checkDf, setCheckDf] = useState<boolean>(false)
  const [fetchData, setFetchData] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [selectHeadCells, setSelectHeadCells] = useState<string[]>(headCells.map((cell) => cell.id))
  const [exportType, setExportType] = useState<string>()
  const isShow = useSelector((state: any) => state.modal.isShow)

  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'SCHEDULES_DOCTOR') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })
    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
      .then((resp) => {
        setDoctors(resp.data)
      })
      .catch((e) => {
        return
      })

    DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
      const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
        return {
          dentistId: d.userId,
          dentistFullname: d.fullname
        }
      })
      setDoctorsMultiple(dentists)
      setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
    })

    return true
  }
  useEffect(() => {
    verifyPermission()
  }, [branchId])

  const renderOperativeType = () => {
    if (operativeTypeId === 0) {
      return `${t('REPORT.FILTER.OPERATIVE_TYPE')}: ${t('REPORT.REPORT_GROUP.ALL')}`
    }
    return `${t('REPORT.FILTER.OPERATIVE_TYPE')}: ${_.get(_.find(operativeType, { operativeTypeId: operativeTypeId }), 'operativeTypeName') || _.get(_.find(operativeType, { operativeTypeId: operativeTypeId }), 'operativeTypeNameEn')} `
  }

  const renderOperative = () => {
    if (operativeId === 0) {
      return `${t('REPORT.FILTER.OPERATIVE')} : ${t('REPORT.REPORT_GROUP.ALL')}`
    }
    return `${t('REPORT.FILTER.OPERATIVE')}: ${_.get(_.find(operative, { operativeId: operativeId }), 'operativeName') || _.get(_.find(operative, { operativeId: operativeId }), 'operativeNameEn')} `
  }

  const fetchSchedules = useCallback(() => {
    let condition: FindAllReportInterface = {
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1]
    }

    if (operativeId && operativeTypeId !== 0) condition = { ...condition, operativeId: operativeId }
    condition = { ...condition, status: _.filter(selectStatus, (d) => d !== 'ALL').join(',') }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (operativeTypeId) condition = { ...condition, operativeType: operativeTypeId }
    if (branchId) condition = { ...condition, branchId: branchId }
    if (rangeDate) {
      if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    ReportApi.reportSchedulesDoctor(condition)

      .then(({ headers, data }) => {
        getSchedulesData(data.rows)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
    setFetchData(false)
  }, [schedulesTypePage, schedulesPageLimit, fetchData])

  const loadDataOperativeType = useCallback(() => {
    TreatmentApi.findAllOperativeType()
      .then(({ data }) => setOperativeType(data))
      .catch(() => {
        return
      })
  }, [])

  const loadDataOperative = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const condition = {
      page: 1,
      pageLimit: 1000,
      sortType: 'asc',
      sortBy: 'operativeId',
      status: 'ACTIVE',
      operativeTypeId: e.target.value
    }
    try {
      const { data } = await TreatmentApi.findOperativeAllActive(condition)
      setOperative(data)
    } catch (error) {
      console.error('Error fetching operative data:', error)
    }
  }


  const handleExport = () => {
    const statusFilter =
      ((selectStatus.length === ["ALL", ...Object.values(APPOINTMENT_STATUS)].length && t('REPORT.REPORT_GROUP.ALL')) || (
        _.map(selectStatus, (option: any, index: number) => {
          return option && (`${t(`APPOINTMENT.STATUS.${option}`)}${index !== _.findLastIndex(selectStatus) && option && `,`}`
          )
        })
      ))

    const doctorsFilter = _.isEmpty(selectDoctors) ? ` ${t('REPORT.FILTER.NO_SELECT')}` : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
      ? `${t('REPORT.FILTER.ALL')}`
      : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
        ?.map((d: any) => d.fullname)
        .slice(0, 3)
        .join(', ')}`


    const report: any = {
      branchName: _.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn'),
      dateStart: rangeDate[0] !== 'Invalid date' ? dateToView(rangeDate[0], true, 'th') : '',
      dateEnd: rangeDate[1] !== 'Invalid date' ? dateToView(rangeDate[1], true, 'th') : '',
      doctorsFilter: doctorsFilter,
      statusFilter: statusFilter,
      operativeTypeFilter: renderOperativeType(),
      operativeFilter: renderOperative(),
      groups: SchedulesData,
      snType: snType,
      t
    }
    ExportSchedulesDoctorToExcel(report)
  }

  const dispatch = useDispatch()

  // This function groups an array into sub-arrays of a specified size
  const groupBy = (array: any[], size: number): any[][] => {
    const groups = []
    for (let i = 0; i < array.length; i += size) {
      groups.push(array.slice(i, i + size))
    }
    return groups
  }

  const groupedHeadCells = useMemo(() => groupBy(headCells, 4), [headCells])
  const handleFilterHeadCells = useCallback(
    (e: React.ChangeEvent<{ value: unknown }>) => {
      const value = Array.isArray(e.target.value) ? e.target.value : ([e.target.value] as string[])

      if (value.includes('NULL') && value.length > 1) {
        const newValues = value.filter((item) => item !== 'NULL')
        setSelectHeadCells(newValues)
      }

      // เมื่อเลือก 'ALL' และ item อื่น ๆ
      if (value.includes('ALL') && value.length > 1) {
        const newValues = value.filter((item) => item !== 'ALL')
        setSelectHeadCells(newValues)
      }
      // เมื่อเลือก 'ALL' เท่านั้น
      else if (value.includes('ALL') && value.length === 1) {
        // Check if current state already has all items selected
        if (selectHeadCells.length === headCells.length + 1 && selectHeadCells.includes('ALL')) {
          setSelectHeadCells(['NULL'])
        } else {
          setSelectHeadCells(['ALL', ...headCells.map((cell) => cell.id)])
        }
      }
      // เมื่อไม่ได้เลือก 'ALL' แต่ item อื่น ๆ เลือกไม่ครบ
      else if (!value.includes('ALL') && value.length !== headCells.length) {
        setSelectHeadCells(value)
      }
      // เมื่อไม่ได้เลือก 'ALL' แต่ item อื่น ๆ เลือกทุกตัว
      else if (!value.includes('ALL') && value.length === headCells.length) {
        setSelectHeadCells(['ALL', ...value])
      }
    },
    [headCells, selectHeadCells]
  )

  const handleToggleCheckbox = (id: string) => {
    if (id === 'ALL' || selectHeadCells.includes(id)) {
      const newValue = selectHeadCells.includes(id) ? selectHeadCells.filter((value) => value !== id) : [...selectHeadCells, id]

      const event = {
        target: { value: newValue }
      }

      handleFilterHeadCells(event as React.ChangeEvent<{ value: unknown }>)
    } else {
      const newValue = [...selectHeadCells, id]
      const event = {
        target: { value: newValue }
      }

      handleFilterHeadCells(event as React.ChangeEvent<{ value: unknown }>)
    }
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }
  const handleChangeRowsPerPage = (limit: number) => setSchedulesPageLimit(limit)
  const handleChangePage = (val: number) => setSchedulesPage(val)
  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }
  useEffect(() => {
    loadDataOperativeType()
    fetchSchedules()
  }, [fetchSchedules, loadDataOperativeType])

  return (
    <Box className={'border-0 h-100 no-print'}>
      <HeaderCard text={t(`REPORT.REPORT_NAME.SCHEDULES_DOCTOR`)} />
      <Box padding="16px">
        <Grid container spacing="10px">
          <Grid container spacing="10px" pt={2}>
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <SelectInput
                label={t('REPORT.FILTER.BRANCH')}
                value={branchId}
                onChange={(e: any) => {
                  setBranchId(Number(e.target.value))
                  setSchedulesPage(1)
                }}
                options={[
                  ...(Array.isArray(branches)
                    ? branches.map((b: any) => ({
                      value: b.branchId,
                      name: b.branchName || b.branchNameEn || '',
                    }))
                    : [])]}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <InputSecondNewRangePicker
                inputHeight={40}
                value={rangeDate || emptyRangePicker}
                onchange={(val: any) => {
                  setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                  setSchedulesPage(1)
                  setSchedulesTypePage(1)
                }}
                label={''}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <SelectCheckBoxInput
                label={t('REPORT.FILTER.APPOINTMENT_STATUS')}
                options={[
                  ...Object.values(APPOINTMENT_STATUS).map((status) => ({
                    id: status,
                    name: t(`APPOINTMENT.STATUS.${status}`),
                  }))
                ]}
                selected={selectStatus}
                onChange={(ids: string[]) => {
                  setSelectStatus(ids);
                }}
                fullWidth
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <SelectCheckBoxInput
                label={t('USER_DOCTOR')}
                options={doctors.map((d: any) => ({
                  id: d.userId,
                  name: d.fullname
                }))}
                selected={selectDoctors}
                onChange={(ids: any) => {
                  setSelectDoctors(ids)
                }}
                fullWidth
                width="100%"
              />
            </Grid>
          </Grid>
          <Grid container spacing="10px" pt={2}>
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <SelectInput
                label={t('REPORT.FILTER.OPERATIVE_TYPE')}
                value={operativeTypeId}
                onChange={e => {
                  setOperativeTypeId(e.target.value)
                  setOperativeId(0)
                  loadDataOperative(e)
                  setSchedulesPage(1)
                }}
                options={[
                  { value: 0, name: t('REPORT.REPORT_GROUP.ALL') },
                  ...(Array.isArray(operativeType)
                    ? operativeType.map((b: any) => ({
                      value: b.operativeTypeId,
                      name: b.operativeTypeName
                    }))
                    : [])]}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={2} >
              <SelectInput
                label={t('REPORT.FILTER.OPERATIVE')}
                value={operativeId}
                onChange={e => {
                  setOperativeId(e.target.value)
                  setSchedulesPage(1)
                }}
                options={[
                  { value: 0, name: t('REPORT.REPORT_GROUP.ALL') },
                  ...(Array.isArray(operative)
                    ? operative.map((b: any) => ({
                      value: b.operativeId,
                      name: b.operativeName
                    }))
                    : [])]}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} xl={8}>
              <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                <MainButton
                  onClick={() => {
                    setFetchData(true)
                    setSchedulesPage(1)
                    setLoading(true)
                  }}
                  title={t('INPUT.SEARCH')}
                  type='primary'
                  variant='contained'
                  style={{ width: '120px' }}
                />
                <UseStyled.DropdownDocument>
                  <Dropdown.Toggle id="dropdown-basic" className="ml-xl-auto">
                    {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        dispatch(showModal())
                        setExportType('Excel')
                      }}
                    >
                      {t('Excel')}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        dispatch(showModal())
                        setExportType('PDF')
                      }}
                    >
                      {t('PDF')}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </UseStyled.DropdownDocument>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <SchedulesList
            selectHeadCells={headCells.map((cell) => cell.id)}
            exportFilter={{
              header: (
                <UseStyled.Styles className="pt-3">
                  <table style={{ border: 'none', borderCollapse: 'collapse' }}>
                    <tr>
                      <td style={{ border: 'none', textAlign: 'left', fontSize: '14px' }} colSpan={8}>
                        {t(`REPORT.REPORT_NAME.SCHEDULES_DOCTOR`)}
                      </td>
                    </tr>
                    <tr style={{ fontSize: '13px' }}>
                      <td style={{ border: 'none', marginRight: '5px' }}>{t('REPORT.FILTER.BRANCH')}: </td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{t('REPORT.FILTER.DATE_START')} </td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{rangeDate[0] !== 'Invalid date' ? dateToView(rangeDate[0]) : ''}</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{t('REPORT.FILTER.DATE_END')} </td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{rangeDate[1] !== 'Invalid date' ? dateToView(rangeDate[1]) : ''}</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{t('REPORT.FILTER.DOCTOR')}:</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{t('REPORT.FILTER.APPOINTMENT_STATUS')}:</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{((selectStatus.length === ["ALL", ...Object.values(APPOINTMENT_STATUS)].length && <span>{t('REPORT.REPORT_GROUP.ALL')}</span>) || (
                        <Box className="text-ellipsis">
                          {_.map(selectStatus, (option: any, index: number) => {
                            return option && (
                              <span>
                                {t(`APPOINTMENT.STATUS.${option}`)}
                                {index !== _.findLastIndex(selectStatus) && option && `,`}
                              </span>
                            )
                          })}
                        </Box>
                      ))}</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>
                        {_.isEmpty(selectDoctors)
                          ? ` ${t('REPORT.FILTER.NO_SELECT')}`
                          : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
                            ? `${t('REPORT.FILTER.ALL')}`
                            : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
                              ?.map((d: any) => d.fullname)
                              .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
                              .join(', ')}`}
                      </td>

                      <td style={{ border: 'none', marginRight: '5px' }}>{renderOperativeType()}</td>
                      <td style={{ border: 'none', marginRight: '5px' }}>{renderOperative()}</td>
                    </tr>
                  </table>
                </UseStyled.Styles>
              )
            }}
            page={schedulesPage}
            pageLimit={schedulesPageLimit}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={SchedulesData}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            componentRef={componentRef}
          />
        </Box>
        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <SchedulesDoctorStaus
            date={rangeDate}
            page={1}
            pageLimit={schedulesPageLimit}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={SchedulesData}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
          />
        </Box>
      </Box>
      <PrintStyles />

      <PageModal
        isOpen={isShow}
        size={'L'}
        title={`${t('REPORT.TITLE.EXPORT_PDF')} ${exportType}`}
        handleClose={() => dispatch(closeModal())}
        onCloseCancel={true}
        onCloseSubmit={true}
        onSubmit={{ onClick: () => null }}
        onCancel={{ onClick: () => dispatch(closeModal()) }}
        overflow={true}
      >
        <>
          <Col sm={12} md={12} xl={12} className={'pt-2 px-1'}
            onClick={() => {
              setCheckDf(!checkDf)
              setSchedulesPage(1)
            }}>
            <div></div>
            <FilterSelect
              formControlClass={'filter filter-headCells'}
              formControlStyle={{ maxWidth: 'unset !important' }}
              multiple
              fullWidth={true}
              // style={{ position: 'fixed', top: 50, zIndex: 1 }}
              renderValue={(e) => {
                if (selectHeadCells.includes('NULL') && selectHeadCells.length === 1) return `${t('REPORT.FILTER.COLUMN_EXPORT')}: ${t('REPORT.FILTER.NO_SELECT')}${t('REPORT.FILTER.COLUMN_EXPORT')}`
                else if (_.includes(selectHeadCells, 'ALL')) return `${t('REPORT.FILTER.COLUMN_EXPORT')}:${t(`REPORT.FILTER.ALL`)}`
                else {
                  return `${t('REPORT.FILTER.COLUMN_EXPORT')}:${headCells
                    .filter((d: any) => selectHeadCells.includes(d.id))
                    ?.map((d: any) => t(d.labelKey))
                    .join(', ')}`
                }
              }}
              label={t('REPORT.FILTER.COLUMN_EXPORT')}
              selectId="select-headCells"
              value={selectHeadCells}
              labelId="label-headCells"
              options={[
                <MenuItem
                  className="py-1"
                  key="ALL"
                  value="ALL"
                  onClick={() => {
                    if (!selectHeadCells.includes('ALL')) {
                      const simulatedEvent = {
                        target: {
                          value: [...selectHeadCells, 'ALL']
                        }
                      }
                      handleFilterHeadCells(simulatedEvent as React.ChangeEvent<{ value: unknown }>)
                    }
                  }}
                >
                  <InputCheckbox value="ALL" checked={selectHeadCells.includes('ALL') || selectHeadCells.length === headCells.length} onChange={handleFilterHeadCells} />
                  {t(`REPORT.FILTER.ALL`)}
                </MenuItem>,
                ...groupedHeadCells.map((group, groupIndex) => (
                  <div key={`group-${groupIndex}`} style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                    {group.map((cell: any) => (
                      <div key={cell.id} style={{ flex: 1 }}>
                        <MenuItem className="py-1" key={cell.id} value={cell.id} onClick={() => handleToggleCheckbox(cell.id)}>
                          <InputCheckbox label={''} value={cell.id} checked={selectHeadCells.includes(cell.id)} onChange={() => handleToggleCheckbox(cell.id)} />
                          {t(cell.labelKey)}
                        </MenuItem>
                      </div>
                    ))}
                  </div>
                ))
              ]}
            />
          </Col>
          <div style={{ height: '70vh', overflow: 'auto' }}>
            <SchedulesList
              selectHeadCells={selectHeadCells}
              exportFilter={{
                header: (
                  <UseStyled.Styles className="pt-3">
                    <table style={{ border: 'none', borderCollapse: 'collapse' }}>
                      <tr>
                        <td style={{ border: 'none', textAlign: 'left', fontSize: '16px' }} colSpan={8}>
                          {t(`REPORT.REPORT_NAME.SCHEDULES_DOCTOR`)}
                        </td>
                      </tr>
                      <tr style={{ fontSize: '14px' }}>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px', fontWeight: '400' }}>{t('REPORT.FILTER.BRANCH')}: </td>
                          <td style={{ border: 'none', marginRight: '5px' }}>{_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}</td>
                        </TableSortLabel>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px', fontWeight: '400' }}>{t('REPORT.FILTER.DATE_START')} </td>
                          <td style={{ border: 'none', marginRight: '5px' }}>{rangeDate[0] !== 'Invalid date' ? dateToView(rangeDate[0]) : ''}</td>
                          <td style={{ border: 'none', marginRight: '5px', fontWeight: '400' }}>{t('REPORT.FILTER.DATE_END')} </td>
                          <td style={{ border: 'none', marginRight: '5px' }}>{rangeDate[1] !== 'Invalid date' ? dateToView(rangeDate[1]) : ''}</td>
                        </TableSortLabel>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px', fontWeight: '400' }}>{t('REPORT.FILTER.APPOINTMENT_STATUS')}:</td>
                          <td style={{ border: 'none', marginRight: '5px' }}>{((selectStatus.length === ["ALL", ...Object.values(APPOINTMENT_STATUS)].length && <span>{t('REPORT.REPORT_GROUP.ALL')}</span>) || (
                            <Box className="text-ellipsis">
                              {_.map(selectStatus, (option: any, index: number) => {
                                return option && (
                                  <span>
                                    {t(`APPOINTMENT.STATUS.${option}`)}
                                    {index !== _.findLastIndex(selectStatus) && option && `,`}
                                  </span>
                                )
                              })}
                            </Box>
                          ))}</td>
                        </TableSortLabel>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px', fontWeight: '400' }}>{t('REPORT.FILTER.DOCTOR')}:</td>
                          <td style={{ border: 'none', marginRight: '5px' }}>
                            {_.isEmpty(selectDoctors)
                              ? ` ${t('REPORT.FILTER.NO_SELECT')}`
                              : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
                                ? `${t('REPORT.FILTER.ALL')}`
                                : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
                                  ?.map((d: any) => d.fullname)
                                  .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
                                  .join(', ')}`}
                          </td>
                        </TableSortLabel>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px' }}>{renderOperativeType()}</td>{' '}
                        </TableSortLabel>
                        <TableSortLabel>
                          <td style={{ border: 'none', marginRight: '5px' }}>{renderOperative()}</td>{' '}
                        </TableSortLabel>
                        <tr />
                      </tr>
                    </table>
                  </UseStyled.Styles >
                )
              }}
              page={schedulesPage}
              pageLimit={schedulesPageLimit}
              rowCount={rowCount}
              sortBy={sortBy}
              sortType={sortType}
              data={SchedulesData}
              onRequestSort={onRequestSort}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleChangePage={handleChangePage}
              componentRef={componentRef}
            />
          </div >

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px',
              width: '100%'
            }}
          >
            <span></span>
            <div style={{ display: 'flex', gap: 2 }}>
              <MainButton
                onClick={() => dispatch(resetModal())}
                title={t('LAB.BUTTON.CANCEL')}
                type='secondary'
                variant='outlined'
                style={{ width: '120px' }}
              />
              {exportType === 'Excel' ? (
                <MainButton
                  onClick={() => handleExport()}
                  title={t('BUTTON.PRINT')}
                  type='primary'
                  variant='contained'
                  style={{ width: '120px' }}
                />
              ) : (
                <FucntionPrint
                  content={() => componentRef.current}
                  docTitle={t('REPORT.REPORT_NAME.SCHEDULES_DOCTOR')}
                  trigger={() => <MainButton
                    onClick={() => null}
                    title={t('BUTTON.PRINT')}
                    type='primary'
                    variant='contained'
                    style={{ width: '120px' }}
                  />
                  }
                  style="@page { size: 1122.519685px 793.7007874px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }}"
                />
              )}
            </div>
          </div>
        </>
      </PageModal >

      < Loading show={loading} type="fullLoading" />
    </Box >
  )
}
